import { DocumentsPlusScanning } from "@app/app-modules/documents-plus/documents-plus-scanning/documents-plus-scanning.model";
import { AbstractAdapter } from "@app/shared/models/adapter.model";
import { FileUploadProgress } from "@app/shared/models/file.model";
import { FileInput } from "@app/shared/components/material-file-input/material-file-input.model";

/**
 * enum: DocumentsPlusUploadStatus
 */
export enum DocumentsPlusUploadStatus {
  Pending,
  Adding,
  Completed,
  Error
}

export interface DocumentsPlusUploadDocuments {
  file: string;
  size: number;
  fileInput: FileInput;
  uploadFileStatus: FileUploadProgress;
  isSelected: boolean;
}

export interface DocumentsPlusModal {
  title?: string;
  companyNumber: string;
  index: string;
  files: File[];
  applicationId: string;
  userId?: string;
  documentType?: string;
  autoAttach?: boolean;
  isWebFace?: boolean;
  close?: boolean;
  disabled?: boolean;
}

export class DocumentsPlusDocumentRequestAdapter extends AbstractAdapter<DocumentsPlusScanning> {
  adapt(rawData: DocumentsPlusScanning) {
    rawData.resolution.value = Number(rawData.resolution.value);
    return rawData;
  }
}

export class DocumentsPlusDocumentResponseAdapter extends AbstractAdapter<DocumentsPlusScanning> {
  adapt(rawData: DocumentsPlusScanning) {
    return rawData;
  }
}
